import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as discountsActions } from "reducers/discounts";
import { actions as accountsActions } from "reducers/accounts";
import { actions as notificationActions } from "reducers/notification";
import * as i18n from "util/i18n";
import { actions as settingsActions } from "reducers/settings";
import DiscountCreation from "./DiscountCreation";
import DiscountsTable from "./DiscountsTable";

const DiscountsPage = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { hasPartials, listEcheqResponse, approvedEcheqs, lotType, fetching } = useSelector(
        (_state) => _state.discounts,
    );
    const [alreadyShowNotiPartials, setAlreadyShowNotiPartials] = useState(false);
    const [, setAllowedForDiscounts] = useState(false);
    const CATEGORY = "discountEcheq";

    useEffect(() => {
        dispatch(discountsActions.resetEcheqFilters());
        dispatch(discountsActions.loadListEcheqRequest());
        dispatch(accountsActions.listAccounts());
        dispatch(discountsActions.loadListDiscountRequest());
        dispatch(settingsActions.getTermsAndConditions(CATEGORY));
        dispatch(settingsActions.loadDocumentsRequest(CATEGORY));
    }, [dispatch]);

    useEffect(() => {
        if (listEcheqResponse && listEcheqResponse.calificacion === 0) {
            dispatch(
                notificationActions.showNotification(i18n.get("echeq.discount.validation.noLine"), "warning", [
                    "discountsPage",
                ]),
            );
            setAllowedForDiscounts(false);
        } else if (listEcheqResponse && listEcheqResponse.calificacion > 0) {
            setAllowedForDiscounts(true);
        }
    }, [listEcheqResponse]);

    useEffect(() => {
        if (!alreadyShowNotiPartials && !!hasPartials) {
            dispatch(
                notificationActions.showNotification(
                    "Tenes un lote con aprobación parcial de Echeqs listo para negociar.",
                    "success",
                    ["discountsPage"],
                ),
            );
            setAlreadyShowNotiPartials(true);
        }
    }, [hasPartials, alreadyShowNotiPartials]);

    const tabsData = [
        {
            text: "A descontar",
            textType: "STRING",
        },
        {
            text: "Descontados",
            textType: "STRING",
        },
    ];

    return (
        <>
            <Notification scopeToShow="discountsPage" />
            <ResponsiveHeader id="payments.discounts.title" defaultTitle="Descuento de Echeqs" />
            <MainContainer showLoader={fetching} className="discounts-echeq">
                <CustomTabs tabsData={tabsData}>
                    <DiscountCreation
                        isDesktop={isDesktop}
                        positionTab={0}
                        approvedEcheqs={approvedEcheqs}
                        lotType={lotType}
                    />
                    <DiscountsTable isDesktop={isDesktop} positionTab={1} />
                </CustomTabs>
            </MainContainer>
        </>
    );
};

export default DiscountsPage;

DiscountsPage.propTypes = {
    isDesktop: bool.isRequired,
};
